import { render, staticRenderFns } from "./SettingsNavigation.vue?vue&type=template&id=4c836d24&scoped=true"
import script from "./SettingsNavigation.vue?vue&type=script&lang=ts"
export * from "./SettingsNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c836d24",
  null
  
)

export default component.exports